const TSlogoSVG = ({ logoClass }: { logoClass?: string | null }) => {
  return (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width='22px'
      height='22px'
      viewBox='0 0 444.7 387.7'
      fill='none'
      className={`icon tulio-solorzano-logo ${logoClass ? logoClass : ''}`}
    >
      <g>
        <path
          className='st6 s-stroke'
          d='M387.6,209.7H277c-3.3,0-6.5-1.5-8.6-4c-2.5-2.7-3.8-7-3.8-13s1.3-10.8,3.8-14.6c2.5-3.8,5.4-5.7,8.6-5.7
		h123.1c17-0.5,30.3-14.7,29.8-31.7c-0.5-16.2-13.5-29.3-29.8-29.8H248.9c-25.6,0-38.3,18.2-38.3,54.5v44.3
		c0,37.8,12.6,57,37.8,57.8h111.2c10.1,0.7,15.1,8.5,15.1,23.2c0,22.1-0.2,17.8-16.2,17.8H47.1c-17.7,0-32.1,14.4-32.1,32.1
		c0,17.7,14.4,32.1,32.1,32.1h340.5c28.1,0,42.1-21.2,42.1-63.7v-40.5C429.7,229.3,415.7,209.7,387.6,209.7z'
        />
        <path
          className='st3 s-fill'
          d='M387.6,209.7H277c-3.3,0-6.5-1.5-8.6-4c-2.5-2.7-3.8-7-3.8-13s1.3-10.8,3.8-14.6c2.5-3.8,5.4-5.7,8.6-5.7
		h123.1c17-0.5,30.3-14.7,29.8-31.7c-0.5-16.2-13.5-29.3-29.8-29.8H248.9c-25.6,0-38.3,18.2-38.3,54.5v44.3
		c0,37.8,12.6,57,37.8,57.8h111.2c10.1,0.7,15.1,8.5,15.1,23.2c0,22.1-0.2,17.8-16.2,17.8H47.1c-17.7,0-32.1,14.4-32.1,32.1
		c0,17.7,14.4,32.1,32.1,32.1h340.5c28.1,0,42.1-21.2,42.1-63.7v-40.5C429.7,229.3,415.7,209.7,387.6,209.7z'
        />
        <circle className='st6 ellipsis-2-stroke' cx='47.1' cy='240.5' r='32.1' />
        <circle className='st3 ellipsis-2-fill' cx='47.1' cy='240.5' r='32.1' />
        <circle className='st6 ellipsis-1-stroke' cx='47.1' cy='141.6' r='32.1' />
        <circle className='st3 ellipsis-3-fill' cx='47.1' cy='141.6' r='32.1' />
        <path d='M12.7,291.7' />
        <path
          className='st4 t-stroke'
          d='M399,15H44.7C28.3,15,15,28.3,15,44.7s13.3,29.7,29.7,29.7h73.1v270.8c-0.7,15.2,11,28.1,26.2,28.8
		c15.2,0.7,28.1-11,28.8-26.2c0-0.9,0-1.7,0-2.6V74.4H399c16.4,0,29.7-13.3,29.7-29.7S415.4,15,399,15L399,15z'
        />
        <path
          className='st7 t-fill'
          d='M399,15H44.7C28.3,15,15,28.3,15,44.7s13.3,29.7,29.7,29.7h73.1v270.8c-0.7,15.2,11,28.1,26.2,28.8
		c15.2,0.7,28.1-11,28.8-26.2c0-0.9,0-1.7,0-2.6V74.4H399c16.4,0,29.7-13.3,29.7-29.7S415.4,15,399,15L399,15z'
        />
      </g>
    </svg>
  );
};
export default TSlogoSVG;
